import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { keyframes } from "@mui/material/styles";

import { useLanguage } from "context/LanguageContext";
import { ACCENT, LOGO_WHITE_SRC } from "layouts/authentication/constants/loginTheme";

const sessionPulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.02);
  }
`;

function SessionLoadingScreen() {
  const { t } = useLanguage();

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        textAlign: "center",
        background: "linear-gradient(170deg, #0d1626 0%, #0a1220 55%, #081020 100%)",
        color: "#fff",
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          top: "-25%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "80%",
          maxWidth: 560,
          height: "55%",
          background:
            "radial-gradient(ellipse closest-side, rgba(30,134,246,0.14) 0%, transparent 72%)",
          pointerEvents: "none",
        }}
      />

      <Fade in timeout={{ enter: 350, exit: 200 }}>
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2.5,
            animation: `${sessionPulse} 1.5s ease-in-out infinite`,
          }}
        >
          <Box
            component="img"
            src={LOGO_WHITE_SRC}
            alt="PayFlex"
            sx={{
              height: { xs: 44, sm: 48 },
              width: "auto",
              maxWidth: 240,
              objectFit: "contain",
            }}
          />
          <CircularProgress size={46} thickness={3.5} sx={{ color: ACCENT }} />
          <Box>
            <Typography
              variant="h6"
              fontWeight={600}
              letterSpacing={0.2}
              sx={{ color: "rgba(255,255,255,0.94)" }}
            >
              {t("login.loading")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: "rgba(255,255,255,0.58)",
                maxWidth: 300,
                lineHeight: 1.6,
              }}
            >
              {t("session.loadingDesc")}
            </Typography>
          </Box>
        </Box>
      </Fade>
    </Box>
  );
}

export default SessionLoadingScreen;
